/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import SourceOperation from './SourceOperation';

/**
 * The AqaSourceActivityForPeriod model module.
 * @module model/AqaSourceActivityForPeriod
 * @version v0
 */
export default class AqaSourceActivityForPeriod {
  /**
   * Constructs a new <code>AqaSourceActivityForPeriod</code>.
   * @alias module:model/AqaSourceActivityForPeriod
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaSourceActivityForPeriod</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaSourceActivityForPeriod} obj Optional instance to populate.
   * @return {module:model/AqaSourceActivityForPeriod} The populated <code>AqaSourceActivityForPeriod</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaSourceActivityForPeriod();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('numberOfCumulatedRows'))
        obj.numberOfCumulatedRows = ApiClient.convertToType(data['numberOfCumulatedRows'], 'Number');
      if (data.hasOwnProperty('operations'))
        obj.operations = ApiClient.convertToType(data['operations'], [SourceOperation]);
      if (data.hasOwnProperty('sourceId'))
        obj.sourceId = ApiClient.convertToType(data['sourceId'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
AqaSourceActivityForPeriod.prototype.id = undefined;

/**
 * @member {Number} numberOfCumulatedRows
 */
AqaSourceActivityForPeriod.prototype.numberOfCumulatedRows = undefined;

/**
 * @member {Array.<module:model/SourceOperation>} operations
 */
AqaSourceActivityForPeriod.prototype.operations = undefined;

/**
 * @member {String} sourceId
 */
AqaSourceActivityForPeriod.prototype.sourceId = undefined;

